import { TenantDto } from '@admin/app/api'
import { TenantConfigFormProfile } from './tenant-config-form.profile'

const mapDtoToFormValues = ({
  id,
  name,
  timezoneId,
  cultureId,
  address,
  truckArrivalWindowDuration,
  unloCodes,
  configs,
  reeferContainerMaxUnpluggedTime,
  temperatureUnit,
}: TenantDto): TenantConfigFormProfile => ({
  id,
  name: name ?? '',
  timezone: timezoneId ?? '',
  culture: cultureId ?? '',
  address: address ?? '',
  truckArrivalWindowDuration: truckArrivalWindowDuration ?? undefined,
  unloCodes: unloCodes ?? [],
  hasDamageCatalogue: configs?.hasDamageCatalogue,
  reeferContainerMaxUnpluggedTime:
    reeferContainerMaxUnpluggedTime || reeferContainerMaxUnpluggedTime === 0
      ? reeferContainerMaxUnpluggedTime
      : undefined,
  temperatureUnit: temperatureUnit ?? undefined,
  allocationRuleWarningThreshold: configs?.allocationRuleWarningThreshold ?? null,
  blockWarningThreshold: configs?.blockWarningThreshold ?? null,
  yardWarningThreshold: configs?.yardWarningThreshold ?? null,
  yardMapAnchorLatitude: configs?.yardMapAnchorLatitude ?? null,
  yardMapAnchorLongitude: configs?.yardMapAnchorLongitude ?? null,
  yardMapNorthRotationDegrees: configs?.yardMapNorthRotationDegrees ?? null,
})

export const TenantConfigFormMapper = {
  mapDtoToFormValues,
}
